// src/runtime/NotificationRuntime/types.ts
// ============================================
// NotificationRuntime - 类型定义（冻结版本 v1.0）
//
// 职责：通知发送层（Email / 企业微信 / 飞书 / 钉钉 / 短信 / Push / Webhook）
//
// 冻结声明：此文件为 v1.0 冻结版本，新增类型只追加不修改
// ============================================

// ============================================
// 通知渠道
// ============================================

export enum NotificationChannel {
  /** 邮件 */
  Email = 'email',
  /** 企业微信 */
  WeChatWork = 'wechat_work',
  /** 飞书 */
  Lark = 'lark',
  /** 钉钉 */
  DingTalk = 'dingtalk',
  /** 短信 */
  SMS = 'sms',
  /** Push 推送（如 JPush/FCM） */
  Push = 'push',
  /** Webhook */
  Webhook = 'webhook',
}

// ============================================
// 通知消息
// ============================================

export interface NotificationMessage {
  /** 标题 */
  title: string;
  /** 内容 */
  content: string;
  /** 内容类型（plain/markdown/html） */
  contentType?: 'plain' | 'markdown' | 'html';
  /** 接收者列表 */
  recipients?: string[];
  /** 抄送 */
  cc?: string[];
  /** 附件（URL 或路径列表） */
  attachments?: string[];
  /** 优先级 */
  priority?: 'low' | 'normal' | 'high' | 'urgent';
  /** 元数据 */
  metadata?: Record<string, unknown>;
}

// ============================================
// 通知结果
// ============================================

export interface NotificationSendResult {
  /** 渠道 */
  channel: NotificationChannel;
  /** 是否成功 */
  success: boolean;
  /** 消息 ID（由渠道返回） */
  messageId?: string;
  /** 错误信息 */
  error?: string;
  /** 发送时间 */
  timestamp: string;
}

// ============================================
// 渠道配置
// ============================================

export interface NotificationChannelConfig {
  /** 渠道类型 */
  channel: NotificationChannel;
  /** 是否启用 */
  enabled: boolean;
  /** 渠道特定配置 */
  config: Record<string, unknown>;
}

// ============================================
// 查询/命令枚举
// ============================================

export enum NotificationQuery {
  /** 列出所有渠道 */
  ListChannels = 'list_channels',
  /** 获取渠道配置 */
  GetChannel = 'get_channel',
  /** 获取发送历史 */
  GetHistory = 'get_history',
}

export enum NotificationCommand {
  /** 发送通知（统一入口） */
  Send = 'send',
  /** 批量发送 */
  SendBatch = 'send_batch',
  /** 注册渠道 */
  RegisterChannel = 'register_channel',
  /** 注销渠道 */
  UnregisterChannel = 'unregister_channel',
}

// ============================================
// 统一返回类型
// ============================================

export interface NotificationResult<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  timestamp: string;
}
